import moment from "moment";

// ITAM-2746 display helpers for the missed-calls panel.

/**
 * Both timestamps are zone-marked instants (backend handoff B-1), so ONE
 * formatter serves both: moment resolves the instant and renders it in the
 * viewer's zone. There is deliberately no per-field variant and no shape
 * detection. If a value ever arrives without a zone marker, that is contract
 * drift to report, not a case to handle here.
 */
export const formatDateTime = (value: string): string =>
  moment(value).format("DD.MM.YYYY. HH:mm");

/** "21 s", or "-" when the backend recorded no wait. */
export const formatWaitTime = (seconds: number | null): string =>
  seconds == null ? "-" : `${seconds} s`;

export const formatCallerName = (
  firstName: string | null,
  secondName: string | null
): string => [firstName, secondName].filter(Boolean).join(" ").trim() || "-";
